module.exports = __webpack_public_path__ + "static/media/martyna.0b213f9f.jpg";